import { render } from "./VaccinationItem.vue?vue&type=template&id=7a19e046&scoped=true"
import script from "./VaccinationItem.vue?vue&type=script&lang=js"
export * from "./VaccinationItem.vue?vue&type=script&lang=js"

import "./VaccinationItem.vue?vue&type=style&index=0&id=7a19e046&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a19e046"]])

export default __exports__